import { View } from "react-native-ui-lib";
import { useActiveTerminal } from "../../utilities/app-state/hooks";
import { Text } from "@towersystems/roam-common-native";

export interface ShiftStatusBadgeProps {}

export const ShiftStatusBadge = ({}: ShiftStatusBadgeProps) => {
  const { loading, terminal } = useActiveTerminal();

  if (loading || !terminal) {
    return null;
  }

  const isOpen = terminal.terminalOpenTime && !terminal.terminalCloseTime;

  return (
    <View style={{ borderWidth: 1, padding: 3, borderRadius: 5 }}>
      <Text style={{ fontSize: 11, fontWeight: "bold" }}>
        {isOpen ? "OPEN" : "CLOSED"}
      </Text>
    </View>
  );
};
